module.exports = __webpack_public_path__ + "img/home1.07658490.jpg";